import { render } from "./ImportGame.vue?vue&type=template&id=7fa7abfe"
import script from "./ImportGame.vue?vue&type=script&lang=js"
export * from "./ImportGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__